import { render, staticRenderFns } from "./StargateSetupContent.vue?vue&type=template&id=07de6156"
import script from "./StargateSetupContent.vue?vue&type=script&lang=js"
export * from "./StargateSetupContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports